import './Location.css';
import { locationImages } from '../../data/location';

const locationSections = [
  {
    title: 'The Bay',
    image: locationImages.bay,
    paragraphs: [
      'The Bay of Kotor is defined by an unusual closeness of water, architecture and mountain.',
      'Its UNESCO’s Natural and Culturo-Historical Region of Kotor — a landscape shaped over centuries by the relationship between the shoreline, historic towns and the steep mountains behind them.',
      'At Villa Mandragora, this geography is not a distant prospect. It is the immediate setting.',
    ],
  },
  {
    title: 'Perast',
    image: locationImages.perast,
    paragraphs: [
      'Perast occupies a narrow strip of waterfront between the bay and the mountain.',
      'Stone palaces and churches recall the town’s maritime past, while St. George and Our Lady of the Rocks sit just offshore.',
      'Perast lends itself to an unhurried few hours — lunch by the water, a short boat crossing, or an evening along the shore.',
    ],
  },
  {
    title: 'Kotor',
    image: locationImages.kotor,
    paragraphs: [
      'Kotor is denser, older and more intricate.',
      'Behind its walls, narrow streets open onto stone squares, Romanesque churches and palaces shaped by centuries of Adriatic trade and cultural exchange.',
      'The fortifications climb the mountain directly behind the old town, giving Kotor a remarkable physical connection between city, rock and water.',
      'Close enough for dinner or an early walk, it is a place worth returning to rather than seeing once.',
    ],
  },
  {
    title: 'Lovćen',
    image: locationImages.lovcen,
    paragraphs: [
      'Lovćen gives the bay its extraordinary sense of scale.',
      'The mountain begins only a few kilometres from the Adriatic and rises to 1,749 metres at Štirovnik, its highest summit.',
      'The Kotor–Lovćen cable car climbs 1,316 metres over 3.9 kilometres in an eleven-minute journey.',
      'In little more than ten minutes, the coast gives way to the high karst landscape above it.',
    ],
  },
  {
    title: 'By Water',
    image: locationImages.byWater,
    paragraphs: [
      'From the water, the geography of the bay becomes clearer.',
      'Perast, Kotor, the islands and the mountain slopes fall into a single landscape. Further out, routes continue towards Mamula, the former submarine tunnels and the Blue Cave.',
      'A private boat is less an excursion than one of the most natural ways to understand the bay.',
    ],
  },
];

function LocationImage({ image, variant = '', eager = false }) {
  return (
    <figure
      className={`location__media ${variant ? `location__media_${variant}` : ''}`}
    >
      <img
        src={image.src}
        alt={image.alt}
        loading={eager ? 'eager' : 'lazy'}
        fetchPriority={eager ? 'high' : 'auto'}
        decoding="async"
      />
    </figure>
  );
}

function location() {
  return (
    <article className="location">
      <header className="location__intro">
        <span className="location__eyebrow">Orahovac · Bay of Kotor</span>
        <h2 className="location__title">Around Villa&nbsp;Mandragora</h2>
        <div className="location__lead">
          <p>
            Villa Mandragora is located on the Bay of Kotor, between Perast and Kotor.
          </p>
          <p>
            Here, historic towns, steep mountains and the bay come together within a remarkably compact landscape.
          </p>
        </div>
      </header>

      <LocationImage image={locationImages.hero} variant="hero" eager />

      <div className="location__chapters">
        {locationSections.map((section, index) => (
          <section
            className={`location__chapter ${index % 2 ? 'location__chapter_reverse' : ''}`}
            key={section.title}
          >
            <div className="location__copy">
              <h3 className="location__chapter-title">{section.title}</h3>
              <div className="location__text">
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            </div>

            <LocationImage
              image={section.image}
              variant={index === 3 ? 'portrait' : 'landscape'}
            />
          </section>
        ))}
      </div>

      <section className="location__closing">
        <div className="location__closing-grid">
          <h3 className="location__closing-title">Within Reach</h3>
          <div className="location__closing-copy">
            <p>
              The scale of the Bay of Kotor is part of its appeal. Perast, Kotor, the
              water and the mountains all remain remarkably close to one another.
            </p>
            <p>
              A morning on the bay can give way to an afternoon in the mountains, with
              centuries-old towns in between.
            </p>
          </div>
        </div>
      </section>
    </article>
  );
}

export default location;
